import { type TicketStatusFilter } from '../../hooks/useTicketList';
import { type TicketSource, type TicketStatus } from '../../services/api/tickets';

export const TICKET_STATUS_LABELS: Record<TicketStatus, string> = {
  draft: 'Utkast',
  rejected: 'Avvisad',
  issue_created: 'GitHub-issue',
};

export const TICKET_STATUS_COLORS: Record<TicketStatus, string> = {
  draft: 'border-indigo-300 text-indigo-700 bg-indigo-50',
  rejected: 'border-slate-300 text-slate-700 bg-slate-50',
  issue_created: 'border-blue-300 text-blue-700 bg-blue-50',
};

export const TICKET_SOURCE_LABELS: Record<TicketSource, string> = {
  auto: 'Nattjobb',
  manual: 'Manuell',
  judge: 'Domaren',
};

// Filtrets ordning är arbetsordningen: utkast först, avklarade sist.
export const TICKET_STATUS_FILTERS: { key: TicketStatusFilter; label: string }[] = [
  { key: 'draft', label: 'Utkast' },
  { key: 'issue_created', label: 'Issues' },
  { key: 'rejected', label: 'Avvisade' },
  { key: 'all', label: 'Alla' },
];
